export default "__VITE_ASSET__DiLDrbrB__"